export const Clipboard = () => {
  const copy = (text) => {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text);
    }

    const el = document.createElement('textarea');
    el.value = text;
    el.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
    document.body.appendChild(el);
    el.focus();
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    return Promise.resolve();
  };

  return { copy };
};
